import React, { Component } from "react";
import classes from "./Spheader.module.css";
import "./spheader.css";
// import Logo from "../images/SafexpayLogo.svg";
import Logo from "assets/img/logos/logo.png";

class Spheader extends Component {
  render() {
    return (
      <>
        <header className="supportus-header supportus-fixed-white-bg">
          <div className="container px-0">
            <div className="topNav px-0 navbar navbar-expand-md item-centered">
              <a href="/" className="navbar-brand">
                <img src={Logo} alt="SafexpayLogo"></img>
              </a>
              <a href="/" className={`${classes.apixp} supportus-home-btn`}>
                Home
              </a>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Spheader;
